import { ROLES, getUserRole, canMonitorAllSetoresRole } from '../contexts/AuthContext';

/**
 * Fase 5 — Data Isolation: anexar ?setor= para FISCAL puro.
 * FISCAL_MONITOR / FINANCEIRO_ANALISTA: leitura ampla — NÃO anexar setor.
 * TODO Backend: toda listagem operacional deve filtrar SQL por req.query.setor
 * (além de unidade/tenant). Não confiar só no front-end.
 */
export function isFiscalSetorial(user, rbacRole) {
  const role = rbacRole || getUserRole(user);
  if (canMonitorAllSetoresRole(role)) return false;
  return role === ROLES.FISCAL && !!(user?.setor);
}

export function getFiscalSetor(user, fiscalSetor) {
  return (fiscalSetor || user?.setor || '').trim() || null;
}

/**
 * Acrescenta &setor=... se o utilizador for FISCAL com setor cadastrado.
 * Aceita path relativo (`/api/...`) ou URL já com query.
 */
export function withSetorScope(path, { user, rbacRole, fiscalSetor, forcar = false } = {}) {
  if (!path) return path;
  const setor = getFiscalSetor(user, fiscalSetor);
  if (!setor) return path;
  if (!forcar && !isFiscalSetorial(user, rbacRole)) return path;
  if (new RegExp(`[?&]setor=`).test(path)) return path;
  return path.includes('?')
    ? `${path}&setor=${encodeURIComponent(setor)}`
    : `${path}?setor=${encodeURIComponent(setor)}`;
}

/**
 * Combina unidade + setor (Fase 4 tenant + Fase 5 isolation).
 */
export function withUnidadeESetor(path, unidade, scope) {
  let url = path;
  if (unidade?.codigo) {
    url = url.includes('?')
      ? `${url}&unidade=${encodeURIComponent(unidade.codigo)}`
      : `${url}?unidade=${encodeURIComponent(unidade.codigo)}`;
  }
  return withSetorScope(url, scope || {});
}
